<template>
  <Select
    v-model="currentLocale"
    :options="availableLocales"
    :placeholder="$t('language.select')"
    option-label="name"
    option-value="iso"
    class="language-selector"
  >
    <template #value="slotProps">
      <div v-if="slotProps.value" class="flex items-center gap-2">
        <i class="pi pi-globe"></i>
        <span>{{ getLocaleName(slotProps.value) }}</span>
      </div>
    </template>
    <template #option="slotProps">
      <div class="flex items-center gap-2">
        <i class="pi pi-globe"></i>
        <span>{{ slotProps.option.name }}</span>
      </div>
    </template>
  </Select>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import Select from 'primevue/select';

import { useTranslation } from '@/composables/useTranslation';

const { locale, changeLocale, locales } = useTranslation();

const currentLocale = computed({
  get: () => locale.value,
  set: async (value: string) => {
    await changeLocale(value);
  },
});

const availableLocales = computed(() => {
  return locales.value.toSorted((a, b) => a.name.localeCompare(b.name));
});

const getLocaleName = (iso: string): string => {
  const locale = locales.value.find(l => l.iso === iso);
  return locale?.name || iso.toUpperCase();
};
</script>

<style scoped>
.language-selector {
  width: 100%;
}
</style>
